'use client';
import type { KeyboardEvent, FormEvent } from 'react';
import { normalizeSignUpEmail } from './sign-up-email';
import { useSignUpState, type SignUpFormProps } from './use-sign-up-state';
import { createSignUpActions } from './sign-up-actions';
export function useSignUpController(props: SignUpFormProps) {
  const state = useSignUpState(props);
  const actions = { ...createSignUpActions(state) };
  const { authBasePath, searchParams, router, setHasEditedName, step, form } =
    state;
  const { handleSubmit } = actions;

  const handleNextStep = async () => {
    if (step === 1) {
      const ok = await form.trigger(['email'], { shouldFocus: true });
      if (ok) {
        // Prune plus aliases before the user advances to the password step
        const email = normalizeSignUpEmail(form.getValues('email'));
        form.setValue('email', email, {
          shouldDirty: true,
          shouldTouch: true,
          shouldValidate: true,
        });
        setHasEditedName(false);
        const params = new URLSearchParams(searchParams.toString());
        params.set('step', '2');
        params.set('email', email);
        router.push(`${authBasePath}?${params.toString()}`);
      }
    } else if (step === 2) {
      const ok = await form.trigger(['name', 'password', 'confirmPassword'], {
        shouldFocus: true,
      });
      if (ok) {
        await form.handleSubmit(handleSubmit)();
      }
    }
  };

  const handleKeyDown = (e: KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      void handleNextStep();
    }
  };

  const handleFormSubmit = (e: FormEvent) => {
    e.preventDefault();
    void handleNextStep();
  };
  return {
    ...state,
    ...actions,
    handleNextStep,
    handleKeyDown,
    handleFormSubmit,
  };
}
